import { Typographies } from '@/theme';
import Colors from '@/theme/constants/Colors';
import { alpha, styled, TextField } from '@mui/material';
import { JTextFieldBaseProps } from '.';

export const TextFieldStyled = styled(TextField)<JTextFieldBaseProps>(
  ({
    theme,
    noBorder,
    attr: { whiteBg } = {},
    fullWidth,
    multiline,
    helpertextinside: helperTextInside,
  }) => ({
    maxWidth: fullWidth ? 'auto' : 200,
    width: fullWidth ? '100%' : 'auto',
    '& .MuiInputBase-input': { paddingTop: !multiline ? 21 : 0 },
    '&:hover .MuiInputBase-root::before, & .MuiInputBase-root::after': {
      borderBottom: 'none',
    },
    /* Chrome, Safari, Edge, Opera */
    'input::-webkit-outer-spin-button ,input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    /* Firefox */
    'input[type=number]': {
      '-moz-appearance': 'textfield',
    },

    '&:hover .MuiInputBase-root::before, &:hover .MuiInputBase-root::after': {
      borderBottom: 'none',
    },

    // Add helper text as ::after element
    '&::after': {
      content: `"${helperTextInside ?? ''}"`,
      position: 'absolute',
      bottom: 5,
      right: 10,
      color: theme.palette.text.primary, // You can customize the color
      fontSize: '12px', // You can customize the font size
    },

    '& .MuiFilledInput-root': {
      '&:before': {
        borderBottom: 'none',
      },

      borderRadius: theme.spacing(1),

      fontSize: Typographies.FONT_SIZE_INPUTS,
      color: theme.palette.text.primary,
      backgroundColor: whiteBg
        ? Colors.WHITE
        : alpha(Colors.COLOR_WHITE_2, 0.4),
    },
    '& .MuiFormLabel-root': {
      color: theme.palette.dark.dark_4,
    },
    '& input:-webkit-autofill': {
      WebkitBoxShadow: `0 0 0px 1000px ${
        whiteBg ? Colors.WHITE : alpha(Colors.COLOR_WHITE_2, 0.4)
      } inset`,
    },
  }),
);
